import {
  IBannerInlinePlaceholderProps,
  SmartComponentProps,
  getBanners,
} from '@tekface/smart-activation';
import { logger } from '@teko/log';
import { TenantEnv } from 'types';

export const getInlineBanners = async (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  context: any,
  config: TenantEnv,
  appId: string,
  flagsup: { [key: string]: boolean },
) => {
  const req = context.req;

  // dedupe within one SSR request
  if (req?.__inlineBannersPromise) return req.__inlineBannersPromise;

  const fetchPromise = (async () => {
    const cookies = req?.headers.cookie || '';
    const userId = cookies.match(/(^| )_tempi_vp=([^;]+)/)?.[2];
    const { baseDomain, getProcessEnv, isMobile } = config;
    const url = new URL(req?.url ?? '', baseDomain);

    try {
      const inlineBanners = await getBanners({
        cookies,
        configs: {
          appId,
          iamId: userId,
          trackingAppId: getProcessEnv('TRACKER_APP_ID'),
          url: url.href,
          isMobile,
        },
        flagsup: flagsup,
        env: getProcessEnv(
          'LANDING_BUILDER_ENV',
        ) as SmartComponentProps<{}>['env'],
      });

      return inlineBanners;
    } catch (err) {
      logger.log(req, err);
      return [];
    }
  })();

  if (req) req.__inlineBannersPromise = fetchPromise;
  return fetchPromise;
};

type BannerItem = NonNullable<
  IBannerInlinePlaceholderProps<{}>['banners']
>[number];

export const getInlineBannerMinHeight = (
  inlineBanners: IBannerInlinePlaceholderProps<{}>['banners'],
  bannerClassname: string,
) => {
  return (
    inlineBanners?.find((item: BannerItem) =>
      item?.className?.includes(bannerClassname),
    )?.height || 0
  );
};
